import { Injectable } from '@angular/core';
import { WordpressService } from './publish-targets/wordpress.service';
import { PostService } from './post.service';
import { PublishTargetDefinition } from '../models/publish-target-definition.interface';

export { PublishTargetDefinition };

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(private wordpressService: WordpressService,
    private postService: PostService) {}


    publishTargets: PublishTargetDefinition[] = [
      { id:'wordpress', name: 'Wordpress', canAuthorize: false, hasApiUser: true, checked: true },
      { id: 'twitter', name: 'Twitter', canAuthorize: true, hasApiUser: true, checked: true, url: 'https://api.twitter.com/2' },
      { id: 'facebook', name: 'Facebook', canAuthorize: true, hasApiUser: true, checked: true, url: 'https://graph.facebook.com' },
      { id: 'instagram', name: 'Instagram', canAuthorize: true, hasApiUser: true, checked: true, url: 'https://graph.facebook.com' },
      { id: 'bluesky', name: 'Bluesky', canAuthorize: false, hasApiUser: true, checked: true, url: 'https://bsky.social' },
      { id: 'mastodon', name: 'Mastodon', canAuthorize: true, hasApiUser: true, checked: true, url: 'https://mastodon.social' },
      { id: 'threads', name: 'Threads', canAuthorize: true, hasApiUser: true, checked: true, url: 'https://threads.net' },
      // Add other social media platforms here
    ];


    /**
     * Get publish target name
     * @param id publish target id
     * @returns
     */
    getPublishTargetName(id: string): string {
      let name = '';
      this.publishTargets.forEach(target => {
        if (target.id === id) {
         name = target.name;
        }
      });
      return name;
    }

  /**
   * Wordpress APIs
   */
  getWordpressService(): WordpressService {
    return this.wordpressService;
  }

  getPostService(): PostService {
    return this.postService;
  }
}
